export class SweepEvent {
}
//# sourceMappingURL=SweepEvent.js.map